import { post } from '..';
import routes from './routes';

const AuthServices = {
  login: async (obj) => {
    const data = await post(routes.login, obj);
    return data;
  },
  logout: async (obj) => {
    const data = await post(routes.logout, obj);
    return data;
  },
  forgetPassword: async (obj) => {
    const data = await post(routes.forgetPassword, obj);
    return data;
  },
  resetPassword: async (obj) => {
    const data = await post(routes.resetPassword, obj);
    return data;
  },
  changePassword: async (obj) => {
    const data = await post(routes.changePassword, obj);
    return data;
  },
}

export default AuthServices